import React from "react";
import "@/App.css";
import { ThemeProvider, useTheme } from "./context/ThemeContext";
import Header from "./components/Header";
import Hero from "./components/Hero";
import About from "./components/About";
import Reviews from "./components/Reviews";
import Services from "./components/Services";
import Process from "./components/Process";
import WhyUs from "./components/WhyUs";
import Projects from "./components/Projects";
import CTA from "./components/CTA";
import Footer from "./components/Footer";
import StickyPromoButton from "./components/StickyPromoButton";

const AppContent = () => {
  const { theme } = useTheme();
  
  return (
    <div className={`${theme.colors.background} min-h-screen`} data-testid="app-container">
      <Header />
      <main>
        <Hero />
        <About />
        <Reviews />
        <Services />
        <Process />
        <WhyUs />
        <Projects />
        <CTA />
      </main>
      <Footer />
      <StickyPromoButton />
    </div>
  );
};

function App() {
  return (
    <ThemeProvider>
      <AppContent />
    </ThemeProvider>
  );
}

export default App;
